import React from "react";
import { ChevronsRight } from "lucide-react";

import { cn } from "@/lib/utils";
import { StrategyRdCoachWorkspaceDiamond } from "./StrategyRdCoachWorkspaceDiamond";

type Props = {
  onOpen: () => void;
  className?: string;
};

/** Workspace account diamond fab — same mark as canvas executing-account node. */
export function StrategyRdCoachFab({ onOpen, className }: Props) {
  return (
    <button
      type="button"
      onClick={onOpen}
      className={cn(
        "fixed bottom-6 right-6 z-40 flex size-[4.5rem] items-center justify-center",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
        className
      )}
      aria-label="Open TES"
      title="Open TES"
    >
      <StrategyRdCoachWorkspaceDiamond size={56} logoClassName="size-9" />
    </button>
  );
}

/**
 * TES minimized: a slim strip on the left edge, where the panel lives, so it closes and opens
 * in place. The panel stays mounted behind it (hidden), so opening is instant.
 */
export function StrategyRdCoachRail({ onOpen, working = false }: { onOpen: () => void; working?: boolean }) {
  return (
    <button
      type="button"
      onClick={onOpen}
      aria-label="Open TES"
      title="Open TES"
      data-strategy-rd-coach-rail=""
      className={cn(
        "group !flex h-full w-11 shrink-0 flex-col items-center gap-3 !rounded-none !border-0 !border-r !border-solid !border-border bg-background !py-3",
        "transition-colors hover:bg-[color:var(--brand-tropical-surf)]/[0.06]",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
      )}
    >
      <StrategyRdCoachWorkspaceDiamond size={30} logoClassName="size-5" />
      <span className="font-[family-name:var(--font-secondary)] text-[11px] font-medium uppercase tracking-[0.14em] text-muted-foreground [writing-mode:vertical-rl] group-hover:text-foreground">
        {working ? "TES is working" : "Ask TES"}
      </span>
      {working ? (
        <span className="size-2 animate-pulse rounded-full bg-[color:var(--brand-tropical-surf)]" aria-hidden />
      ) : null}
      {/* Says which way it opens. */}
      <ChevronsRight className="mt-auto size-4 text-muted-foreground group-hover:text-[color:var(--brand-tropical-surf)]" aria-hidden />
    </button>
  );
}
